<script setup>
import { useDetailsReport } from '#/detailsReport/useDetailsReport'
import PotentialMap from '#/detailsReport/PotentialMap'
import PotentialDetailsV1 from '#/detailsReport/version1/PotentialDetailsV1'
import PotentialDetailsV2 from '#/detailsReport/version2/PotentialDetailsV2'

const { potential, version } = useDetailsReport()
</script>

<template lang="pug">
.cityTitle(v-if="version === 2 && potential && potential.city") Die Liegenschaft in {{ potential.city.name }}
div(:class="`general-info--container-v${version}`")
  potential-map
  potential-details-v1(v-if="version === 1")
  potential-details-v2(v-else-if="version === 2")
</template>

<style scoped lang="sass">
.general-info--container-v1
  width: 100%
  display: flex
  @media screen and (min-width: 1440px)
    flex-direction: row
    justify-content: space-between
  @media screen and (max-width: 1440px)
    flex-direction: column
    margin-bottom: 20px
.cityTitle
  line-height: 130%
  color: #22223C
  font-weight: 700
  @media screen and (min-width: 1440px)
    font-size: 30px
    margin-bottom: 30px
  @media screen and (max-width: 1440px)
    font-size: 20px
    margin-bottom: 16px
</style>
